var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpaceCirclesIcon = function SvgSpaceCirclesIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    stroke: "#4a4a4a",
    strokeDasharray: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66.146,
    cy: 66.146,
    r: 63.552,
    fill: "#f5f5f5",
    strokeWidth: 2.542,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.034,
    cy: 43.845,
    r: 24.757,
    fill: "#d7d7d7",
    strokeWidth: 1.587,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.14,
    cy: 54.996,
    r: 18.894,
    fill: "#d7d7d7",
    strokeWidth: 1.381,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.177,
    cy: 98.652,
    r: 24.757,
    fill: "#d7d7d7",
    strokeWidth: 1.587,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.887,
    cy: 24.19,
    r: 8.927,
    fill: "#d7d7d7",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.458,
    cy: 79.186,
    r: 8.927,
    fill: "#d7d7d7",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.723,
    cy: 88.635,
    r: 8.927,
    fill: "#d7d7d7",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.878,
    cy: 15.497,
    r: 3.04,
    fill: "#d7d7d7",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.359,
    cy: 66.713,
    r: 3.04,
    fill: "#d7d7d7",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.143,
    cy: 27.214,
    r: 3.04,
    fill: "#d7d7d7",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.494,
    cy: 104.699,
    r: 3.04,
    fill: "#d7d7d7",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.08,
    cy: 97.329,
    r: 3.04,
    fill: "#d7d7d7",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.341,
    cy: 36.853,
    r: 8.927,
    fill: "#b6b6b6",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.366,
    cy: 110.369,
    r: 8.927,
    fill: "#b6b6b6",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.381,
    cy: 54.618,
    r: 8.927,
    fill: "#b6b6b6",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.862,
    cy: 37.609,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.262,
    cy: 37.798,
    r: 3.04,
    fill: "#8d8d8d",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.287,
    cy: 108.29,
    r: 3.04,
    fill: "#8d8d8d",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.109,
    cy: 53.484,
    r: 8.927,
    fill: "#b6b6b6",
    strokeWidth: 1.058,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.234,
    cy: 50.838,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.557,
    cy: 61.61,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.628,
    cy: 68.036,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.499,
    cy: 90.002,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.027,
    cy: 82.626,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.468,
    cy: 93.683,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.363,
    cy: 84.579,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.406,
    cy: 96.384,
    r: 3.04,
    fill: "#b6b6b6",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.764,
    cy: 58.294,
    r: 1.442,
    fill: "#d7d7d7",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.668,
    cy: 44.262,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.024,
    cy: 35.175,
    r: 1.442,
    fill: "#8d8d8d",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.77,
    cy: 56.423,
    r: 1.442,
    fill: "#8d8d8d",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.917,
    cy: 58.027,
    r: 1.442,
    fill: "#8d8d8d",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.046,
    cy: 51.746,
    r: 1.442,
    fill: "#8d8d8d",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.552,
    cy: 23.816,
    r: 1.442,
    fill: "#d7d7d7",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.838,
    cy: 39.585,
    r: 1.442,
    fill: "#d7d7d7",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.386,
    cy: 27.959,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.649,
    cy: 21.544,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.874,
    cy: 43.193,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.925,
    cy: 89.03,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.505,
    cy: 67.114,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.422,
    cy: 53.75,
    r: 1.442,
    fill: "#8d8d8d",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.441,
    cy: 105.734,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.623,
    cy: 53.433,
    r: 3.04,
    fill: "#8d8d8d",
    strokeWidth: 0.529,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.404,
    cy: 81.145,
    r: 1.442,
    fill: "#d7d7d7",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.121,
    cy: 80.477,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.135,
    cy: 78.473,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.028,
    cy: 74.597,
    r: 1.442,
    fill: "#d7d7d7",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.836,
    cy: 65.243,
    r: 1.442,
    fill: "#d7d7d7",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.865,
    cy: 100.116,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.309,
    cy: 108.273,
    r: 1.442,
    fill: "#b6b6b6",
    strokeWidth: 0.397,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.102,
    cy: 113.672,
    r: 1.442,
    fill: "#8d8d8d",
    strokeWidth: 0.397,
    opacity: 1
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceCirclesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-circles-icon.018ab4f88ad54e0a8f2794901ac1517d.svg";